var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:{ 'empty-text': !_vm.data.text },style:(_vm.styleObject)},[_c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":_vm.data.isExternalLogo ? _vm.data.logoPath : _vm.logoImport}})]),(_vm.data.text)?_c('div',{staticClass:"text-container"},[_vm._v(" "+_vm._s(_vm.data.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }